import {useEffect,useState} from 'react';

/** Permissions tab of the SAME unified person profile. Owner/admin can
 * grant in-app support review and notifications without a second account. */
export function AppSupportGrant({actorId,locationCode}:{
  actorId:string;locationCode:string;
}){
  const [grant,setGrant]=useState<{enabled:boolean;fixedOwner:boolean}|null>(null);
  const [status,setStatus]=useState('Loading App Support permission…');
  const [busy,setBusy]=useState(false);
  const endpoint='/api/v1/staff/team/'+encodeURIComponent(actorId)+'/app-support';
  const reload=async()=>{
    const response=await fetch(endpoint+'?'+new URLSearchParams({location:locationCode}),{
      credentials:'same-origin',cache:'no-store'});
    const body=await response.json() as {ok:boolean;
      data?:{enabled:boolean;fixedOwner:boolean};error?:{code?:string}};
    if(!response.ok||!body.ok||!body.data)
      throw Error(body.error?.code??'Permission unavailable.');
    return body.data;
  };
  useEffect(()=>{
    let active=true;
    setGrant(null);setStatus('Loading App Support permission…');
    void reload().then(value=>{if(active){setGrant(value);setStatus('');}})
      .catch(e=>{if(active)setStatus(e instanceof Error?e.message:
        'Permission unavailable.');});
    return ()=>{active=false;};
  },[actorId,locationCode]);
  const change=async(enabled:boolean)=>{
    if(busy||grant?.fixedOwner)return;
    setBusy(true);setStatus('Saving…');
    try{
      const response=await fetch(endpoint,{
        method:'PATCH',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({location:locationCode,enabled}),
      });
      const body=await response.json() as {ok:boolean;error?:{code?:string}};
      if(!response.ok||!body.ok)throw Error(body.error?.code??'Permission change failed.');
      setGrant(await reload());setStatus('Saved');
    }catch(e){setStatus(e instanceof Error?e.message:'Permission change failed.');}
    finally{setBusy(false);}
  };
  return <section className="ecfs-staff-permissions" aria-label="App Support permission">
    <h2>App Support</h2>
    {grant&&<label className="ecfs-permission-check">
      <input type="checkbox" aria-label="App Support"
        checked={grant.enabled} disabled={busy||grant.fixedOwner}
        onChange={e=>void change(e.target.checked)}/>
      Can Review App Support Tasks and Receive Notifications
      {grant.fixedOwner&&<em>Owner</em>}
    </label>}
    {status&&<p role="status">{status}</p>}
  </section>;
}
